import { createSelector } from '@reduxjs/toolkit';
import { Decimal } from 'decimal.js';

export const getPointsConversionTierName = (state) => state.pointsConversion.name;
export const getRawLevels = (state) => state.pointsConversion.levels || [];
export const getLevels = createSelector(getRawLevels, (levels) =>
  levels.map((level) => ({ min: new Decimal(level.min), max: new Decimal(level.max || Infinity), rate: new Decimal(level.rate) })),
);
